import { render, staticRenderFns } from "./RequestTypeRadio.vue?vue&type=template&id=e9e64f3e"
import script from "./RequestTypeRadio.vue?vue&type=script&lang=js"
export * from "./RequestTypeRadio.vue?vue&type=script&lang=js"
import style0 from "./RequestTypeRadio.vue?vue&type=style&index=0&id=e9e64f3e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports